module.exports = __webpack_public_path__ + "img/c4.33aa081d.jpg";